import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';

class Endorsements extends Component {
    render() {
        return (
            <div
                style={{
                    backgroundColor: 'white'
                }}>
                <Grid doubling centered columns={4} padded stackable>
                    {this.props.list.edges.map((elem) => {
                        const { src } = elem.node.original;
                        return (
                            <Grid.Column key={src} style={{ textAlign: 'center' }}>
                                <img src={src} alt="Yes" />
                            </Grid.Column>
                        )
                    })}
                </Grid>
            </div>
        );
    }
}

export default Endorsements;


// WEBPACK FOOTER //
// ./src/components/Endorsements/index.jsx